import Page from "../Page";
import Box from "../Box";
import { withRouter } from "react-router-dom";
import { getSchedule } from "../../api/registration";
import Moment from "react-moment";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import LoadingContent from "../LoadingContent";

class SchedulePage extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            schedule: {
                days: [],
                registeredPresentations: [],
            },
            loading: true,
        };
    }

    componentDidMount = () => {
        this._getSchedule();
    }

    _getSchedule = () => {
        getSchedule()
            .then(response => {
                this.setState({
                    schedule: response,
                    loading: false,
                });
            })
            .catch(error => {

            });
    }


    render() {
        if (this.state.loading) {
            return <LoadingContent />
        }

        let { schedule } = this.state;
        let registeredPresentations = schedule.registeredPresentations.filter(rp => rp.paid);

        return (
            <Page title="Conference Registration">
                <div className="d-lg-flex justify-content-end btn-container">
                    <button className="btn btn-primary btn-print-schedule" onClick={() => window.print()}>Print your Schedule</button>
                    <button className="btn btn-primary btn-change-schedule" onClick={() => this.props.history.push("/sessions")}>Change your Schedule</button>
                </div>
                <Box title="Schedule">                             
                    {schedule.days.map((day, index) => (
                        <div key={index}>
                            <div className="header">
                                Day {index + 1} - <Moment format="ddd, MMM D">{day}</Moment>                                
                            </div>                            
                            <div className="divider" />
                            <div className="session-list">
                                {registeredPresentations.filter(presentation => presentation.presentationDate === day).map((presentation, index) => (
                                    <div className="session-item" key={presentation.id}>
                                        <div className="row session-title">
                                            <div className="col-12">
                                                <div><Moment format="h:mm A">{presentation.startTime}</Moment> - <Moment format="h:mm A">{presentation.endTime}</Moment>&nbsp;&nbsp;|&nbsp;&nbsp;{presentation.titleShortName}</div>
                                            </div>
                                        </div>                                                                                
                                        {presentation.therapeuticAreas.length > 0 &&
                                            <div className="row mb-1">
                                                <div className="col-lg-2 col-4">Subjects:</div>
                                                <div className="col-lg-10 col-8">
                                                    {presentation.therapeuticAreas.map((t, index) => (
                                                        <span key={index}>{t.name}{presentation.therapeuticAreas.length -1 === index ? "" : ", "}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        }
                                        {presentation.levelDisplayText && 
                                            <div className="row">
                                                <div className="col-lg-2 col-4">Content Level:</div>
                                                <div className="col-lg-10 col-8">{presentation.levelDisplayText}</div>
                                            </div>
                                        }
                                        {presentation.speakerListing && 
                                            <div className="row">
                                                <div className="col-lg-2 col-4">Speaker(s):</div>
                                                <div className="col-lg-10 col-8">{presentation.speakerListing}</div>                                            
                                            </div>
                                        }                                                                                
                                        <div className="row">
                                            <div className="col-lg-2 col-4">CE Hours:</div>
                                            <div className="col-lg-10 col-8">{presentation.contactHours}</div>
                                        </div>
                                        {presentation.presentationFee > 0 && 
                                            <div className="row">
                                                <div className="col-lg-2 col-4">Additional Fee:</div>
                                                <div className="col-lg-10 col-8">${presentation.presentationFee.toFixed(2)}</div>                                            
                                            </div>
                                        }              
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="presentation-description" dangerouslySetInnerHTML={{__html: presentation.description}} />                                                            
                                            </div>
                                        </div>
                                        {index !== registeredPresentations.filter(presentation => presentation.presentationDate === day).length - 1 &&
                                            <div className="divider" />
                                        }
                                    </div>
                                ))}
                                {registeredPresentations.filter(presentation => presentation.presentationDate === day).length === 0 &&
                                    <div className="info-box mt-3 mb-4">
                                        No sessions were selected for this day.
                                    </div>
                                }
                            </div>
                        </div>
                    ))}                    
                </Box>
            </Page>
        );
    }
}

export default withRouter(SchedulePage);